module.exports = __webpack_public_path__ + "img/carteira-entrada.44b66d8a.svg";